/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Task/GetAllotmentsForAmadeus
 */
export interface GetAllotmentsForAmadeusRequestBuilder extends BaseRequestBuilder<GetAllotmentsForAmadeusRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<number[]>}
     * @throws {ProblemDetails} error when the service returns a 500 status code
     */
     post(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<number[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetAllotmentsForAmadeusRequestBuilderUriTemplate = "{+baseurl}/Task/GetAllotmentsForAmadeus";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetAllotmentsForAmadeusRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetAllotmentsForAmadeusRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollectionOfPrimitive",
        responseBodyFactory:  "number",
        requestBodyContentType: "application/json",
        requestInformationContentSetMethod: "setContentFromScalar",
    },
};
/* tslint:enable */
/* eslint-enable */
